// Interfaces
import { IDropdown } from 'interfaces/common';

export const PDF = 'application/pdf';
export const DOC = '.doc';
export const DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
export const XLS = 'application/vnd.ms-excel';
export const XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
export const PPT = 'application/vnd.ms-powerpoint';
export const PPTX = 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
export const ZIP = 'application/x-zip-compressed';
export const RAR = 'application/x-rar-compressed';

export const FILE_SIZE_0_3_MB = 128000; // 0.128mb
export const FILE_SIZE_0_5_MB = 512000; // 0.512mb
export const FILE_SIZE_1_MB = 524288; // 1mb
export const FILE_SIZE_2_MB = 2097152; // 2mb
export const FILE_SIZE_3_MB = 3145728; // 3mb

export const FILE_MIME_FORMATTED = [
  {
    type: 'file',
    mimes: {
      PDF,
      DOC,
      DOCX,
      XLS,
      XLSX,
      PPT,
      // PPTX,
      // ZIP,
      // RAR,
    },
  },
  {
    type: 'image',
    mimes: {
      JPG: 'image/jpeg',
      PNG: 'image/png',
      // JPG: '.jpg',
      // JPEG: '.jpeg',
      // PNG: '.png',
    },
  },
];

/**
 * @description Extract extension to be flat array
 *
 * @param {"image"|"file"} type
 *
 * @return {string[]} string[]
 */
const flattenExtensions = (type: 'image' | 'file'): string[] => {
  return Object.values(FILE_MIME_FORMATTED.find(file => file.type === type)?.mimes || {});
};

/**
 * @description Extract mimes
 *
 * @param {"image"|"file"} type
 *
 * @return {any} any
 */
const extractMimes = (type: 'image' | 'file'): any => {
  return FILE_MIME_FORMATTED.find(file => file.type === type)?.mimes;
};

export const FILE_IMAGE_EXTENSIONS = flattenExtensions('image');
export const FILE_DOCUMENT_EXTENSIONS = flattenExtensions('file');
export const FILE_IMAGE_MIMES = extractMimes('image');
export const FILE_DOCUMENT_MIMES = extractMimes('file');
export const ALL_FILE_EXTENSIONS = [...FILE_IMAGE_EXTENSIONS, ...FILE_DOCUMENT_EXTENSIONS];

export enum ANOTHER_FILE_STATES {
  DELETE = 'delete',
}

export const MAPPED_FILE_TYPES = (): IDropdown[] => {
  let options: IDropdown[] = [];

  for (const [key, value] of Object.entries({ ...FILE_DOCUMENT_MIMES, ...FILE_IMAGE_MIMES })) {
    const mapKey = key as string;
    const mapValue = value as string;

    options.push({
      label: mapKey,
      value: mapValue,
    });
  }

  return options;
};

export const FORMAT_BYTES = (bytes: number, decimals: number = 2): number | string => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};
